import { Injectable } from '@angular/core';
import { ClientStateService } from '../../client-state/logic/client-state.service';
import { ExtFilesService } from '../../ext-files/logic/ext-files.service';
import { LoggingService } from '../../logging/logic/logging.service';
import {
  VisibilityRuleService,
  VisibilityRule,
} from '../visibility-rule-service';

/**
 * Visibility Service checks for given Rules if something is visible
 */
@Injectable({
  providedIn: 'root',
})
export class BranchHasPhotodocuPhotos implements VisibilityRuleService {
  // Public Member
  public readonly name: VisibilityRule = 'branchhasphotodocuphotos';

  // Lifecycle
  constructor(
    private logger: LoggingService,
    private clientStateService: ClientStateService,
    private extFileService: ExtFilesService,
  ) {}

  // VisibilityRuleService
  public isVisible(params: any): boolean {
    console.log(this.constructor.name, 'execute isVisible');
    const branchId = this.clientStateService.theState.getValue()?.branchId;
    console.log(
      this.constructor.name,
      'execute isVisible for branch',
      branchId,
    );
    const extFiles = this.extFileService.getPhotoDocuExtFilesForId(branchId);
    console.log(
      this.constructor.name,
      'execute isVisible found extFiles',
      extFiles?.length,
    );
    return extFiles?.length > 0;
  }

  // Private Functions
}
